/*------------------------------------*\
	#BACK TO TOP
\*------------------------------------*/

const element = document.querySelector(".js-back-to-top");
let isScrolling;

window.onscroll = function () {
	if (element) {
		element.classList.remove('is-visible');
	}
};

window.addEventListener('scroll', function (event) {
	const documentHeight = document.body.scrollHeight,
		currentScroll = window.scrollY + window.innerHeight,
		offset = 500;

	window.clearTimeout(isScrolling);

	isScrolling = setTimeout(function () {
		if (element && window.scrollY >= offset) {
			element.classList.add('is-visible');
		}
	}, 2000);

	if (currentScroll + offset > documentHeight) {
		if (element) {
			element.classList.add('is-visible');
		}
	} else {
		if (element) {
			element.classList.remove('is-visible');
		}
	}
}, false);

if (element) {
	element.addEventListener('click', function (event) {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	})
}
